import React from "react";
import { Step2ScheduleReserveContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import queryString from "query-string";
import moment from "moment";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { userService } from "apiServices";
import { MONTH_EN, MONTH_TH, RENDER_MONTH } from "utils/functions/date";
import {
  CelendarWidget,
  HeaderBackMusicHallWidget,
} from "widgets";
import { Headers, Displays, Buttons, Inputs, Navigations } from "components";

class Step2ScheduleReserveContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    const query = this.buildQueryString();
    this.fetchData(query);
  }

  fetchData = async (query) => {
    let resArr = await Promise.all([
      userService.GET_ROOM_BOOKING_LIST(query),
      userService.GET_ROOM_AVAILABILITY_LIST(query),
    ]);
    if (resArr) {
      this.setState({
        data: resArr[0].data,
        dataHoliday: resArr[1].data,
        isLoading: false,
      });
    }
  };

  // QUERY FLOW
  // =========================================
  // =========================================
  buildQueryString = (additionalParams = {}) => {
    const { router } = this.props;
    const urlParams = queryString.parse(router.location.search);
    const defaultQuery = {
      room_id: router.params.id,
      start_date: moment().startOf("week").format("YYYY-MM-DD"),
      end_date: moment().endOf("week").format("YYYY-MM-DD"),
    };
    const finalParams = {
      ...defaultQuery,
      ...urlParams,
      ...additionalParams,
    };
    const cleanParams = Object.entries(finalParams)
      .filter(
        ([key, value]) => value !== null && value !== undefined && value !== "",
      )
      .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
    const query = `?${Object.entries(cleanParams)
      .map(([key, value]) => `${key}=${value}`)
      .join("&")}`;
    router.navigate(
      `${ROUTE_PATH.MUSIC_HALL}/${router.params.id}/booking/2${query}`,
    );
    return query;
  };
  handleChangeMonth = (e) => {
    this.setState({
      dateValue: e,
    });
    this.handleJoinQuery({
      start_date: moment(`${e.value}-01`, "YYYY-MM-DD")
        .startOf("week")
        .format("YYYY-MM-DD"),
    });
  };
  onClickPrevWeek = () => {
    const { router } = this.props;
    const urlParams = queryString.parse(router.location.search);
    this.handleJoinQuery({
      start_date: moment(urlParams.start_date)
        .startOf("week")
        .subtract(7, "days")
        .format("YYYY-MM-DD"),
    });
  };
  onClickNextWeek = () => {
    const { router } = this.props;
    const urlParams = queryString.parse(router.location.search);
    this.handleJoinQuery({
      start_date: moment(urlParams.start_date)
        .add(7, "days")
        .format("YYYY-MM-DD"),
    });
  };
  handleJoinQuery = (additionalQuery) => {
    const query = this.buildQueryString(additionalQuery);
    this.setState({
      isLoading: true,
    });
    this.fetchData(query);
  };

  handleBack = () => {
    const { router } = this.props;
    const { id } = this.props.router.params;
    this.props.router.navigate(
      `${ROUTE_PATH.MUSIC_HALL}/${id}/booking/1${router.location.search}`,
    );
  };
  handleNextStep = () => {
    const { router } = this.props;
    const { id } = this.props.router.params;
    this.props.router.navigate(
      `${ROUTE_PATH.MUSIC_HALL}/${id}/booking/3${router.location.search}`,
    );
  };

  render() {
    const { router, i18n, t } = this.props;
    const isPreview =
      queryString.parse(router.location.search)?.is_preview === "true";
    const { isLoading, dataHoliday, dateValue } = this.state;
    const urlParams = queryString.parse(router.location.search);
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      {
        name: t("Music Hall Bangkok", { ns: "common" }),
        path: `${ROUTE_PATH.MUSIC_HALL_AND_PRACTICE}/6913fddf8682dc3a88f16b7c`,
      },
    ];
    return (
      <Step2ScheduleReserveContainerStyled isPreview={isPreview}>
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <div className="step_schedule_reserve_container">
          {!isPreview ? (
            <div className="header_layout">
              <Headers.NewPageHeader
                title={"YAMAHA MUSIC  HALL, BANGKOK"}
                sub_title={"Rental Registration form "}
              />
            </div>
          ) : (
            <div className="header_backhome_layout">
              <HeaderBackMusicHallWidget room_booking_id={router.params.id} />
            </div>
          )}
          {isPreview && (
            <div className="title_preview">
              {t("Review Information", { ns: "common" })}
            </div>
          )}
          <div className="detail_layout">
            <Displays.TitleReserve
              title_reserve={t("Check Availability Before Booking", {
                ns: "room",
              })}
            />
          </div>
          {isLoading ? (
            <Displays.Loading />
          ) : (
            <>
              <div className="dropdown_layout">
                <Inputs.DropdownSelect
                  value={dateValue}
                  placeholder={
                    i18n.language === "en"
                      ? RENDER_MONTH(moment(urlParams?.start_date).format("MM"))
                          ?.en
                      : RENDER_MONTH(moment(urlParams?.start_date).format("MM"))
                          ?.th
                  }
                  options={
                    i18n.language === "en"
                      ? MONTH_EN.map((e) => ({
                          ...e,
                          label: `${e.label} ${moment().format("YYYY")}`,
                          value: `${moment().format("YYYY")}-${e.value}`,
                        }))
                      : MONTH_TH.map((e) => ({
                          ...e,
                          label: `${e.label} ${moment().format("YYYY")}`,
                          value: `${moment().format("YYYY")}-${e.value}`,
                        }))
                  }
                  onChange={this.handleChangeMonth}
                />
              </div>
              <div>
                <CelendarWidget
                  type="room"
                  startDate={urlParams?.start_date}
                  endDate={urlParams?.end_date}
                  timeData={TIME_DATA}
                  timeSlotData={
                    dataHoliday.docs.filter((e) => e.reason_closed !== "1") ||
                    []
                  }
                  holidayData={
                    dataHoliday.docs.filter((e) => e.reason_closed === "1") ||
                    []
                  }
                  onClickPrevWeek={this.onClickPrevWeek}
                  onClickNextWeek={this.onClickNextWeek}
                />
              </div>
              <div className="button_layout">
                <div className="button1">
                  <Buttons.BgStandard
                    label={t("Back", { ns: "common" })}
                    onClick={this.handleBack}
                  />
                </div>
                <div className="button2">
                  <Buttons.BgStandard
                    label={t("Next", { ns: "common" })}
                    onClick={this.handleNextStep}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </Step2ScheduleReserveContainerStyled>
    );
  }
}

const TIME_DATA = [
  { label: "Time" },
  { label: "07.00\n08.00", value: { startTime: "07.00", endTime: "08.00" } },
  { label: "08.00\n09.00", value: { startTime: "08.00", endTime: "09.00" } },
  { label: "09.00\n10.00", value: { startTime: "09.00", endTime: "10.00" } },
  { label: "10.00\n11.00", value: { startTime: "10.00", endTime: "11.00" } },
  { label: "11.00\n12.00", value: { startTime: "11.00", endTime: "12.00" } },
  { label: "13.00\n14.00", value: { startTime: "13.00", endTime: "14.00" } },
  { label: "14.00\n15.00", value: { startTime: "14.00", endTime: "15.00" } },
  { label: "15.00\n16.00", value: { startTime: "15.00", endTime: "16.00" } },
  { label: "16.00\n17.00", value: { startTime: "16.00", endTime: "17.00" } },
  { label: "17.00\n18.00", value: { startTime: "17.00", endTime: "18.00" } },
  { label: "18.00\n19.00", value: { startTime: "18.00", endTime: "19.00" } },
  { label: "19.00\n20.00", value: { startTime: "19.00", endTime: "20.00" } },
  { label: "20.00\n21.00", value: { startTime: "20.00", endTime: "21.00" } },
  { label: "21.00\n22.00", value: { startTime: "21.00", endTime: "22.00" } },
];

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  withTranslation(["room", "common"])(
    withRouter(Step2ScheduleReserveContainer),
  ),
);
